import loadable from '@loadable/component';
import React from 'react';

import connectRoute from 'app/routes/connectRoute';

const ListPageContainer = loadable(() => import('app/components/list/ListPageContainer'));

const ListPageRoute = () => {
  return <ListPageContainer />;
};

export default connectRoute(ListPageRoute);
